import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function isAlphaNumeric(value: string) {
    return (
        (value >= "0" && value <= "9") ||
        (value >= "a" && value <= "z") ||
        (value >= "A" && value <= "Z")
    );
}
